import cnLocale from "element-ui/lib/locale/lang/zh-CN";

export default {
  common: {
    success: "成功",
    error: "错误",
    fail: "失败",
    null: "无",
    reminder: "提示",
    notNull: "该项不能为空",
    formatInfo: "请按要求填写信息",
    permissionWarning: "无该操作权限",
    clickForMore: "点击查看",
    clickToCopy: "点击复制",
    download: "下载",
    copySuccess: "已复制到剪切板上",
    emailFormat: "请填写正确的邮箱格式",
    confirmTitle: "确认",
    uploadLimit: "*只能上传 {type} 文件，且不超过{size}M",
    uploadErrorMessage: "上传失败，请重传",
    loading: "加载中",
    submitting: "提交中，请耐心等待",
    saving: "保存中",
  },
  table: {
    operation: "操作",
    team: "团队",
    ratio: "分值占比",
    rules: "得分规则",
    title: "名称",
    class: "班级",
    score: "成绩",
    type: "类别",
    status: "状态",
    submitted: "已提交",
    unsubmitted: "未提交",
  },
  button: {
    add: "添加",
    save: "保存",
    cancel: "取消",
    confirm: "确认",
    back: "返回",
    look: "查看",
    join: "加入",
    edit: "修改",
    upload: "上传",
  },
  filter: {
    noStart: "未开始",
    doing: "进行中",
    marking: "阅卷中",
    end: "已结束",
    null: "未知",
    exam: "考试",
    exercise: "练习",
    contest: "比赛",
  },
  // loginPage.vue
  loginPage: {
    welcome: "欢迎登录 Mooctest",
    login: "登录",
    register: "注册",
    email: "邮箱",
    inputEmail: "请输入邮箱",
    password: "密码",
    inputPsd: "请输入密码",
    emailNotNull: "邮箱不可为空",
    passwordNotNull: "密码不可为空",
    loginError: "用户名或密码错误",
    manageEntrance: "教师端入口",
    forgetPassword: "忘记密码?",
    ForgetPassword: "忘记密码",
    sendEmailInfo: "已向 {e} 发送重置密码邮件，请注意查收",
    emailPlaceholder: "请输入您的注册邮箱",
    captcha: "验证码",
    changeOne: "看不清，换一张",
  },
  // loginPage.vue
  registerPage: {
    welcome: "欢迎注册 Mooctest",
    login: "登录",
    register: "注册",
    username: "用户名",
    inputRealName: "请输入真实姓名",
    email: "邮箱",
    inputEmail: "请输入邮箱",
    password: "密码",
    inputPsd: "请输入密码",
    confirm: "确认密码",
    inputPsdAgain: "请再次输入密码",
    psdLength: "请保证密码长度在{s}到{l}位之间",
    nameLength: "请保证用户名在{s}到{l}位之间",
    psdDiffer: "两次输入密码不一致",
    emailFormat: "请填写正确的邮箱格式",
    userExist: "用户已存在",
    // "Ensure that the password contains {s} to {l} characters",
  },
  // Leftbar.vue
  leftBar: {
    compWebsite: "大赛官网",
    forum: "慕测论坛",
    tool: "工具下载",
    compEntrance: "大赛入口",
    help: "使用帮助",
    teacherAuth: "成为教师",
  },
  // footer
  footer: {
    compEntrance: "大赛入口",
    compWebsite: "大赛官网",
    compGuide: "大赛导航",
  },
  narBar: {
    competition: "大赛",
    home: "首页",
    task: "任务",
    class: "班级",
    loginAndRegister: "登录/注册",
    account: "个人",
    profile: "个人信息",
    logout: "登出",
  },
  // competitionInfo
  competitionInfo: {
    compInfo: "大赛信息",
    qq: "官方QQ群",
    helpInfo: "帮助信息",
    wx: "大赛公众号",
    manageEntrance: "教师端入口",
  },
  // competition/List
  competitionList: {
    compList: "大赛列表",
    signUp: "报名",
    quit: "退赛",
    enter: "参赛",
    // teamEdit
    stage: "当前赛段",
    nextRound: "晋级下一轮",
    nextRoundTrue: "您已获得下一轮比赛资格",
    nextRoundFalse: "尚未获得下一轮资格",
    mentor: "指导老师",
    teammate: "团队成员",
    emailFormat: "请填写正确的邮箱格式",
    name: "用户名",
    email: "慕测注册邮箱",
    numberLimit: "最多填写{n}位",
    contestRule: "参赛须知",
    teamInfoTip: "团队信息与part1保持一致",
    teamTip:
      "注意：报名后自动成为该团队队长，队员无需报名，由队长添加团队成员即可",
    goToFill: "去填写",
    part2tip:
      "Web测试赛项分为两个部分，Part1包括功能测试和性能测试各一题，Part2包括功能测试一题，" +
      "请务必完成两个部分的题目",
    profileTip: "请先完善个人信息",
    quitTip: "确定要退出比赛吗？",
  },
  // competition/Detail
  competitionDetail: {
    examInfo: "考试信息",
    examName: "考试名称",
    paperName: "试卷名称",
    time: "起止时间",
    initiator: "发起人",
    examiner: "出卷人",
    submitted: "已提交",
    requirement: "测试需求",
    description: "描述",
    document: "需求文档",
    key: "客户端秘钥",
  },
  // Task.vue
  task: {
    task: "我参与的任务",
    putKeyword: "请输入检索关键词",
  },
  // task/detail.vue
  taskDetail: {
    detail: "任务详情",
    type: "任务类型",
    name: "任务名称",
    time: "起止时间",
    initiator: "发起人",
    paperName: "试卷名称",
    creator: "创建者",
    difficulty: "难度",
    taskInfo: "任务描述",
    description: "描述",
    document: "需求文档",
    problem: "题目",
    key: "客户端秘钥",
    file: "文件",
    annexFile: "答题附件",
    downloadAnnex: "下载答题附件",
    answerFile: "提交答案",
    uploadAnswerLimit: "*只能上传.java文件，且不超过1M",
    uploadAnswerLimitWU: "*只能上传文件 zip 或者xlsx | xls文件，且不超过10M",
    downloadSubmitAnswer: "查看我的提交",
    upload: "上传文件",
    uploadAgain: "重新上传",
    uploadLimit: "*只能上传xlsx和xls文件",
    record: "成绩记录",
    totalScore: "总分",
    targetFile: "测试目标",
    developerNotice:
      "注意：开发者做题方式全新升级，取消Eclipse客户端及密钥，点击了解更多",
    submitDocForWEB: "测试用例文档",
    submitCodeForWEB: "测试脚本代码",
    submitPackageForWEB: "截图压缩包",
  },
  // class/index.vue
  classList: {
    myClass: "我加入的班级",
    joinClass: "加入班级",
    joinClassL: "加入班级",
    class: "班级",
    classId: "班级Id",
    inputId: "请输入班级编号",
    teacherName: "教师用户名",
    inputTeacher: "请输入教师用户名",
    joinError: "教师名或编号错误",
    allowJoinError: "该班级不允许加入",
  },
  // class/detail.vue
  classDetail: {
    detail: "班级详情",
    title: "班级名称",
    id: "班级编号",
    size: "班级人数",
  },
  // Profile
  profile: {
    profile: "个人信息",
    editProfile: "修改个人信息",
    editProfileL: "修改个人信息",
    name: "用户名",
    identity: "身份",
    stuNumber: "学号",
    tel: "电话",
    email: "邮箱",
    school: "学校",
    location: "所在地",
    city: "城市",
    mentor: "指导老师",
    mentor_email: "指导老师邮箱",
    attachment: "附件",
    student: "学生",
    teacher: "老师",
    uploadLimit: "只能上传jpg/png文件，且不超过500kb",
    editPassword: "修改密码",
    password: "密码",
    // edit
    editPasswordL: "修改密码",
    newPsd: "新密码",
    oldPsd: "旧密码",
    confirmPsd: "确认密码",
    newPsdNull: "请输入密码",
    oldPsdNull: "请输入旧密码",
    confirmPsdNull: "请再次输入密码",
    psdDiffer: "两次输入密码不一致",
    confirmRemove: "确认移除文件",
    fileExceed: "你只能上传一个文件",
    nameLength: "请保证用户名在{s}到{l}位之间",
    toAdd: "暂无，待补充",
    competitionInfoTip: "与比赛报名以及证书发布相关，请认真填写",
  },
  // 下载
  download: {
    downloadPage: "插件下载",
    downloadAddress: "下载地址",
    plugin: "插件",
    eclipsePlugin: "eclipse 插件下载",
    eclipse: "eclipse",
    maven: "Maven",
    address: "地址",
    jdk: "jdk",
    linuxEclipse: "Linux含插件eclipse下载",
    macEclipse: "Mac含插件eclipse下载",
    win64WithPluginEclpiseDownload: "win64含插件eclipse下载",
    win64jdk: "win64 jdk1.8下载地址",
    jmeter: "jmeter插件下载",
    embedded: "嵌入式测试工具",
  },
  pwdReset: {
    resetPassword: "重置密码",
    manageEntrance: "教师端入口",
    stuEntrance: "学生端入口",
    successInfo: "修改成功，前往登录页面",
  },
  requestError: {
    serverError: "无法连接到服务器",
    loginTimeout: "登录超时，请重新登录",
    timeout: "请求超时，请重试",
  },
  ...cnLocale,
};
